/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Paypal_ErrorInputs */

const en_checkout_paypal_error = /** @type {(inputs: Checkout_Paypal_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong with PayPal. Please try again.`)
};

/**
* | output |
* | --- |
* | "Something went wrong with PayPal. Please try again." |
*
* @param {Checkout_Paypal_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_paypal_error = /** @type {((inputs?: Checkout_Paypal_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Paypal_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_paypal_error(inputs)
});